import { useEffect, useState } from 'react';

/**
 * Tracks whether the viewport is at or below `breakpoint` (px). Returns `false`
 * during SSR and the first client render so markup stays hydration-stable, then
 * flips to the real value in an effect. Default breakpoint matches the point
 * where the desktop side-by-side layouts stop fitting and switch to the stacked
 * mobile layouts from the design mockup.
 */
export function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const update = () => setIsMobile(mql.matches);
    update();
    mql.addEventListener('change', update);
    return () => mql.removeEventListener('change', update);
  }, [breakpoint]);

  return isMobile;
}
